import React from "react";
import { FPTwoBackgroundFullScreenView } from "../../Simple/FPTwoBackgroundFullScreenView/FPTwoBackgroundFullScreenView";
import { FrontColors } from "../../../../models/FrontColors";
import { SpacingRow } from "../../../BuildingBlocks/SpacingRow";
import { Background } from "../../../BuildingBlocks/Background";
import { Sticky } from "../../../BuildingBlocks/Sticky";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import { FPLandingTitle } from "../../Simple/FPLandingTitle/FPLandingTitle";
import { Shape } from "../../../BuildingBlocks/Shape";
import { WeightBold } from "../../../WeightBold/WeightBold";
import { FPMarketingParagraph } from "../../Simple/FPMarketingParagraph/FPMarketingParagraph";
import { FPGuideDesktop } from "../../Simple/FPGuide/FPGuideDesktop";

export const Guides = [
    {
        imageUrl: "/static/img/probate-guide-1.jpg",
        href: "https://blog.sailprobate.co.uk/posts/how-to-find-a-will/",
        blurb: "How do I find a will?",
    },
    {
        imageUrl: "/static/img/probate-guide-2.jpg",
        href: "https://blog.sailprobate.co.uk/posts/finding-the-deceased-assets/",
        blurb: "How do I find and value a deceased person's assets?",
    },
    {
        imageUrl: "/static/img/probate-guide-3.jpg",
        href: "https://blog.sailprobate.co.uk/posts/how-do-i-obtain-a-copy-of-a-grant-of-probate/",
        blurb: "How do I obtain a copy of a Grant of Probate?",
    },
    {
        imageUrl: "/static/img/probate-guide-4.jpg",
        href: "https://blog.sailprobate.co.uk/posts/how-does-probate-work-if-there-is-no-will/",
        blurb: "How does probate work if there is no will?",
    },
    {
        imageUrl: "/static/img/probate-guide-5.jpg",
        href: "https://blog.sailprobate.co.uk/posts/can-you-apply-for-probate-online/",
        blurb: "Can you apply for probate online?",
    },
    {
        imageUrl: "/static/img/probate-guide-6.jpg",
        href: "https://blog.sailprobate.co.uk/posts/how-long-does-a-probate-property-sale-take/",
        blurb: "How long does a probate property sale take?",
    },
    {
        imageUrl: "/static/img/probate-guide-7.jpg",
        href: "https://blog.sailprobate.co.uk/posts/how-do-i-know-if-need-to-apply-for-probate/",
        blurb: "How do I know if I need to apply for probate?",
    },
    {
        imageUrl: "/static/img/probate-guide-8.jpg",
        href: "https://blog.sailprobate.co.uk/posts/do-you-have-to-have-a-solicitor-for-probate/",
        blurb: "Do you have to have a solicitor for probate?",
    },
];

type TLandingPageDesktopGuidesProps = {

};

export const FPLandingPageDesktopGuides = (props: React.PropsWithChildren<TLandingPageDesktopGuidesProps>): JSX.Element => {

    return (
        <FPTwoBackgroundFullScreenView
            leftColor={FrontColors.PROBATE_0}
            rightColor={FrontColors.PROBATE_0}
            leftCutPoint="50%"
            rightCutPoint="50%"
            height="auto"
        >
            <SpacingRow
                spacing={`79px`}
                childSize="1fr 2px 1fr"
                alignItems="flex-start"
            >
                {/* COLUMN - LEFT */}
                <Background 
                    backgroundPosition={"relative"}
                    padding={`240px 0px 250px`}
                    height="2900px"
                >
                    <Sticky top="240px">
                        <SpacingColumn spacing={`80px`}>
                            <SpacingColumn spacing={`40px`}>
                                <FPLandingTitle
                                    color={FrontColors.NEUTRAL_18}
                                    align="center"
                                    size={56}
                                >
                                    Read our probate guides.
                                </FPLandingTitle>
                                
                                <FPMarketingParagraph
                                    color={FrontColors.NEUTRAL_18}
                                    align="center"
                                    size={20}
                                >
                                    Find <WeightBold>anwsers</WeightBold> to common questions, from <br/> some of the <WeightBold>best</WeightBold> written <WeightBold>guides</WeightBold> <br/> on the internet.
                                </FPMarketingParagraph>
                            </SpacingColumn>
                        </SpacingColumn>
                    </Sticky>
                </Background>

                {/* BORDER */}
                <Background 
                    backgroundPosition={"relative"}
                    padding={`80px 0px 120px`}
                    height="2900px"
                >
                    <Sticky top="80px">
                        <Shape
                            width="1px"
                            height="700px"
                            color={FrontColors.NEUTRAL_10_2}
                        />
                    </Sticky>
                </Background>

                {/* COLUMN - RIGHT */}
                <Background 
                    padding={`240px 0px 240px`}
                    width="480px"
                    height="2900px"
                >
                    <Sticky top="80px">
                        <SpacingColumn spacing="40px">
                            {Guides.map((guide, index) => (
                                <FPGuideDesktop
                                    key={index}
                                    width="350px"
                                    imageHeight="200px"
                                    href={guide.href}
                                    imageUrl={guide.imageUrl}
                                    blurb={guide.blurb}
                                />
                            ))}
                        </SpacingColumn>
                    </Sticky>                
                </Background>

            </SpacingRow>
        </FPTwoBackgroundFullScreenView>
    );
};
